import React from 'react'
import { Dialog, DialogTitle, DialogContent, IconButton, Typography, Box, SvgIcon } from '@mui/material'
import type { DialogProps } from '@mui/material'
import { ReactComponent as CloseIcon } from '../../../assets/images/Close.svg'
import Divider from '@mui/material/Divider'

export interface SearchModalProps {
    open: boolean
    onClose: () => void
    title: string
    leftPanel: React.ReactNode
    children: React.ReactNode
    leftPanelWidth?: number
    maxWidth?: DialogProps['maxWidth']
    leftPanelRef?: React.Ref<HTMLDivElement>
}

const SearchModal: React.FC<SearchModalProps> = ({
    open,
    onClose,
    title,
    leftPanel,
    children,
    leftPanelWidth = 300,
    maxWidth = 'lg',
    leftPanelRef,
}) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth={maxWidth} aria-labelledby="search-modal-title">
            <DialogTitle
                id="search-modal-title"
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
            >
                <Typography variant="22x600">{title}</Typography>
                <IconButton onClick={onClose} size="small" sx={{ p: 0.5, color: 'figma.grayscale.tier3' }}>
                    <SvgIcon component={CloseIcon} inheritViewBox fontSize="medium" />
                </IconButton>
            </DialogTitle>
            <Divider variant="middle" />
            <DialogContent sx={{ display: 'flex', overflow: 'hidden' }}>
                <Box
                    ref={leftPanelRef}
                    sx={{
                        flexShrink: 0,
                        width: leftPanelWidth,
                        overflowY: 'auto',
                        p: 2,
                        borderRight: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    {leftPanel}
                </Box>
                <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 1.5, pt: 0 }}>{children}</Box>
            </DialogContent>
        </Dialog>
    )
}

export default SearchModal
